export default __webpack_public_path__ + "static/media/Ask-A-Medical-Expert_1112x646.3d568ee4.jpg";